import { z } from "zod/v4";

export const PasswordSchema = z
	.string({
		error: "Password field is required.",
	})
	.min(8, "Password should be minimum 8 chars");
